import {
  Skeleton,
  SkeletonButton,
  SkeletonCard,
  SkeletonText,
  SkeletonTitle,
} from './SkeletonComponents';

// Activity Feed Page Skeleton (global activity page)
export function ActivityFeedSkeleton() {
  return (
    <div className="max-w-2xl mx-auto space-y-8">
      {/* Header with Action Button */}
      <div className="flex flex-col sm:flex sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <div>
              <SkeletonTitle className="w-32 h-8 mb-2" />
              <SkeletonText className="w-48" />
            </div>
            {/* Hidden notification bell placeholder - matches actual page */}
            <div className="w-9 h-9 opacity-0 pointer-events-none" />
          </div>
        </div>
        {/* Quick Expense Button Skeleton - button already includes keyboard shortcut */}
        <SkeletonButton className="w-44 h-10" />
      </div>

      {/* Activity Feed Skeleton */}
      <div>
        <SkeletonTitle className="w-40 mb-6" />
        <div className="space-y-6">
          {[1, 2, 3, 4, 5, 6, 7].map(i => (
            <SkeletonCard key={i} className="p-4">
              <div className="flex items-start gap-3">
                {/* Activity Icon */}
                <Skeleton className="w-10 h-10 rounded-full shrink-0" />

                {/* Activity Content */}
                <div className="flex-1 space-y-3">
                  {/* Header with user and timestamp */}
                  <div className="flex justify-between items-start">
                    <div>
                      <Skeleton className="w-32 h-4 mb-1" />
                      <Skeleton className="w-12 h-3" />
                    </div>
                  </div>

                  {/* Main content */}
                  <div>
                    <Skeleton className="w-3/4 h-4 mb-2" />
                    <Skeleton className="w-1/2 h-3 mb-2" />
                    <Skeleton className="w-40 h-3" />
                  </div>

                  {/* Category and date */}
                  <div className="flex gap-2">
                    <Skeleton className="w-24 h-3" />
                    <Skeleton className="w-2 h-3" />
                    <Skeleton className="w-20 h-3" />
                  </div>

                  {/* Amount section */}
                  <div className="flex items-center gap-2 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                    <Skeleton className="w-4 h-4 rounded-full" />
                    <Skeleton className="w-32 h-4" />
                  </div>

                  {/* Reactions and Comments */}
                  <div className="space-y-3">
                    {/* Reactions */}
                    <div className="flex gap-2">
                      {[1, 2, 3, 4].map(j => (
                        <Skeleton key={j} className="w-12 h-7 rounded-full" />
                      ))}
                      <Skeleton className="w-20 h-7 rounded-full" />
                    </div>

                    {/* Comments preview */}
                    {i % 2 === 0 && (
                      <div className="space-y-2">
                        <div className="flex gap-2">
                          <Skeleton className="w-7 h-7 rounded-full" />
                          <div className="flex-1">
                            <Skeleton className="w-24 h-3 mb-1" />
                            <Skeleton className="w-full h-3" />
                          </div>
                        </div>
                        <Skeleton className="w-32 h-6 rounded-sm" />
                      </div>
                    )}

                    {/* Comment input */}
                    <div className="flex gap-2">
                      <Skeleton className="w-7 h-7 rounded-full" />
                      <Skeleton className="flex-1 h-8 rounded-lg" />
                    </div>
                  </div>
                </div>
              </div>
            </SkeletonCard>
          ))}

          {/* Load More Button */}
          <div className="flex justify-center pt-4">
            <SkeletonButton className="w-32 h-10" />
          </div>
        </div>
      </div>
    </div>
  );
}
